<template lang="pug">
    #modal-tecnico
        span.subtitle-modal-tecnico Processo selecionado
        .processo(v-if='processos.length > 0')
            span.processo-item(v-for='processo in processos' :key='processo.codigoImovel') {{ processo.codigoImovel }}
        .modal-tecnico-content(:class='{ "--loading" : isLoading }')
            div.chips-container
                chip-component(
                    v-for="(tecnico, index) in tecnicosVinculados"
                    :key="tecnico.id"
                    :label="tecnico.nome"
                    border-radius="5px"
                    icon="mdi-close"
                    :class="{ 'chip-pendente': tecnico.pendenteDesvinculacao }"
                    @iconAction="marcarParaDesvincular(index)"
                )
            text-area-input-component.input-despacho(
                v-model='vinculacaoTecnico.despacho',
                label='Despacho*:',
                placeholder=''
            )
        .modal-footer(style="display: flex; justify-content: space-between")
            button-component(
                label='Cancelar',
                icon='mdi-close',
                backgroundColor='var(--primary-gray)',
                color="var(--primary-light-smoke)",
                @click.native="cancelar"
            )
            button-component(
                label='Desvincular',
                icon='mdi-link-variant',
                :disabled='isLoading || !tecnicosVinculados.length',
                @click.native="desvincularTecnico"
            )
</template>

<script>
import { desvincular } from "@/services/processo.service";
export default {
  name: "ModalDesvinculacaoTecnico",
  props: {
    processos: {
      type: Array,
      required: false,
      default: () => [],
    },
    tecnicos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      vinculacaoTecnico: {
        despacho: "",
      },
      tecnicosVinculados: this.tecnicos.map((tecnico) => ({
        ...tecnico,
        pendenteDesvinculacao: false,
      })),
      isLoading: false,
    };
  },
  methods: {
    marcarParaDesvincular(index) {
      this.tecnicosVinculados[index].pendenteDesvinculacao =
        !this.tecnicosVinculados[index].pendenteDesvinculacao;
    },
    async desvincularTecnico() {
      const tecnicosParaDesvincular = this.tecnicosVinculados.filter(
        (tecnico) => tecnico.pendenteDesvinculacao
      );

      if (
        this.processos.length > 0 &&
        tecnicosParaDesvincular.length > 0 &&
        this.vinculacaoTecnico.despacho
      ) {
        const mensagensErro = [];
        const mensagensSucesso = [];

        try {
          for (const processo of this.processos) {
            for (const tecnico of tecnicosParaDesvincular) {
              try {
                await desvincular(processo.id, {
                  idUsuarioTecnico: tecnico.id,
                  despacho: this.vinculacaoTecnico.despacho,
                });
                mensagensSucesso.push(
                  `${tecnico.nome} desvinculado ao processo do imóvel ${processo.codigoImovel}`
                );
              } catch (error) {
                const mensagemErro =
                  error?.response?.data?.message ||
                  error.message ||
                  "Erro inesperado.";
                mensagensErro.push(
                  `Erro ao desvincular técnico ${tecnico.nome} ao processo ${processo.id}: ${mensagemErro}`
                );
              }
            }
          }

          if (mensagensSucesso.length > 0) {
            this.imprimirMensagensSucesso(mensagensSucesso);
          }

          if (mensagensErro.length > 0) {
            this.imprimirMensagensErro(mensagensErro);
          }
        } catch (err) {
          this.$toast({
            showClose: true,
            message:
              err?.response?.data?.message ||
              "Erro inesperado ao desvincular técnicos!",
            type: "error",
            duration: 15000,
          });
        }
        this.atualizarGrid();
        this.cancelar();
      } else {
        alert("Dados preenchidos incorretamente!");
      }
    },
    imprimirMensagensSucesso(mensagensSucesso) {
      if (mensagensSucesso.length) {
        const mensagemSucesso = mensagensSucesso.join("<br/><br/>");
        this.$toast({
          showClose: true,
          message: `Técnicos desvinculados com sucesso!<br/><br/>${mensagemSucesso}`,
          type: "success",
          dangerouslyUseHTMLString: true,
          duration: 15000,
        });
      }
    },
    imprimirMensagensErro(mensagensErro) {
      if (mensagensErro.length) {
        const mensagemErro = mensagensErro.join("<br/><br/>");
        this.$toast({
          showClose: true,
          message: `Falha ao desvincular alguns técnicos:<br/><br/>${mensagemErro}`,
          type: "error",
          dangerouslyUseHTMLString: true,
          duration: 10,
        });
      }
    },
    removeTecnico(index) {
      this.tecnicosVinculados.splice(index, 1);
    },
    cancelar() {
      this.$emit("cancelar", true);
    },
    atualizarGrid() {
      this.$emit("atualizarGrid", true);
    },
  },
};
</script>

<style scoped>
.modal-tecnico {
  width: 300px;
  color: var(--primary-black);
}

.chip-pendente {
  background-color: var(--primary-red) !important;
  color: white !important;
  border: 1px solid var(--primary-red) !important;
}

.subtitle-modal-tecnico {
  font-weight: 600;
  margin-bottom: 15px;
}

.processo {
  margin: 5px 0px 20px 0px;
}

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding-top: 5px;
  max-width: 400px;
}
</style>
